<template>
	<div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
		<el-page-header @back="goBack" :content="id ? '编辑行业模板' : '添加行业模板'"></el-page-header>
		<el-form label-position="right" :rules="rules" ref="ruleForm" :model="item" label-width="auto">
			<el-form-item label="所属行业" prop="industry_id">
				<el-select v-model="item.industry_id" filterable placeholder="请选择">
					<el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="模板名称" prop="name">
				<el-input v-model="item.name" placeholder="请输入模板名称"></el-input>
			</el-form-item>

			<el-form-item>
				<el-button size="big" type="primary" @click="checkSubmit">保存</el-button>
			</el-form-item>
			<el-form-item>
				<el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
					<span>您确认保存嘛</span>
					<span slot="footer" class="dialog-footer">
						<el-button @click="dialogVisible = false">取 消</el-button>
						<el-button type="primary" @click="submit">确 定</el-button>
					</span>
				</el-dialog>
			</el-form-item>
		</el-form>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				item: {},
				isLoad: false,
				dialogVisible: false,
				id: this.$route.query.id,
				options: [],
				rules: {
					industry_id: [{
						required: true,
						message: '所属行业未选择',
						trigger: 'blur'
					}, ],
					name: [{
						required: true,
						message: '请输入模板名称',
						trigger: 'blur'
					}, ]
				}
			}
		},
		created() {
			this.loadData()
		},
		methods: {
			async loadData() {
				if (this.isLoad) {
					return
				}
				this.isLoad = !this.isLoad
				let res = ""
				res = await this.axios.post('/admin/data/listIndustryForSelect', {
				})
				this.options = res.data.list

				if (this.id) {
					res = await this.axios.post('/admin/industry.template/detail', {
						id: this.id
					})
					if (res) {
						// item是基础信息
						this.item = res.data.detail
					}
				}
				this.isLoad = !this.isLoad
			},
			// 后退一步
			goBack() {
				this.$router.back(-1)
			},
			checkSubmit() {
				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						this.dialogVisible = true
					} else {
						this.$message.warning("请检查表单信息是否正确");
						return false;
					}
				});
			},

			// 提交
			submit() {
				if (this.isLoad) {
					return
				}
				this.isLoad = !this.isLoad
				this.dialogVisible = false
				let url = ''
				if (this.id) {
					url = '/admin/industry.template/update'
					this.item.id = this.id
				} else {
					url = '/admin/industry.template/add'
				}
				this.axios.post(url, this.item)
					.then(() => {
						this.isLoad = !this.isLoad
						this.$message.success({
							message: '保存成功'
						});
						this.goBack()
					})
					.catch(() => {
						this.isLoad = !this.isLoad
					})
			}
		}
	}
</script>
<style scoped>
</style>·
